module.exports = __webpack_public_path__ + "img/30.167183ab.jpg";